<template>
    <div class="container-fluid mt-4">
        <div class="row">
            <div class="col-12">
                <div class="card">

                    <!-- Card body -->
                    <div class="card-body">
                        <vue-form :state="formstate" @submit.prevent="create()">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <validate tag="div">
                                            <h4>Reseña</h4>
                                            <Rating  v-model="rating" :cancel="false" />
                                        </validate>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <validate tag="div">
                                            <label class="form-control-label" for="email">Testimonio*</label>
                                            <Textarea class="form-control" v-model="sOpinion" rows="5" cols="10" />
                                        </validate>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
									<button type="submit" class="btn btn-primary " >Guardar</button>
                            </div>
                        </vue-form>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
	import VueForm from "vue-form"
	import options from "../../validations/validations.js";

    export default {
    name: 'AddReview',
    components: {
    },
    data() {
        return {
            formstate: {},
            sOpinion: 'Esta plataforma ha sido de mucha utilidad para mi vida formación profesional. Cada curso que he tomado ha sido de mucha ayuda para mi preparación, agradezco infinitamente a GCA por las posibilidades que brinda a profesionales como yo',
            rating: 5
        }
    },
    methods: {
        create(){
            this.showMessage('Exito', 'Testimonio guardado correctamente!!!!', 'success')
            this.$emit('eventname')
        }
    },

    async mounted() {

    },
    watch: {
        
    }
}
</script>
